import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20entertainment%20newsroom%20backdrop%20with%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20abstract%20geometric%20patterns%20suggesting%20digital%20media%20landscape%2C%20cinematic%20atmosphere%20with%20soft%20glowing%20particles%2C%20modern%20editorial%20aesthetic%2C%20rich%20dark%20tones%20with%20warm%20highlights%2C%20sleek%20sophisticated%20composition%2C%20no%20text%20or%20logos&width=1800&height=900&seq=hero-bg-51cg&orientation=landscape"
          alt="51吃瓜网 - 全网吃瓜爆料平台"
          title="51吃瓜网 - 每日吃瓜爆料黑料视频在线观看"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left lg:pl-4">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-tight tracking-tight">
              {heroData.title}
              <br />
              <span className="text-accent-500 italic">{heroData.titleHighlight}</span>
            </h1>
            <p className="mt-5 md:mt-6 text-base md:text-lg text-foreground-200 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              {heroData.subtitle}
            </p>
            <div className="mt-7 md:mt-8 flex flex-col sm:flex-row items-center gap-3 lg:justify-start justify-center">
              <Link
                to="/category/wanghong-baoliao"
                className="px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
              >
                {heroData.ctaPrimary}
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/app"
                className="px-8 py-3.5 text-sm font-semibold text-background-50 border-2 border-background-50/30 rounded-full hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.ctaSecondary}
                <i className="ri-download-line ml-2"></i>
              </Link>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative w-full aspect-[4/3] max-w-lg ml-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20modern%20smartphone%20floating%20in%20dark%20space%20displaying%20trending%20social%20media%20content%20with%20warm%20amber%20glow%2C%20breaking%20news%20alert%20aesthetic%2C%20cinematic%20product%20photography%2C%20elegant%20minimal%20composition%2C%20rich%20dark%20background%20with%20warm%20light%20rays%2C%20premium%20tech%20atmosphere%2C%20sophisticated%20editorial%20style&width=800&height=600&seq=hero-featured-51cg&orientation=landscape"
                alt="51吃瓜网热门爆料"
                title="51吃瓜网 - 实时追踪网红大瓜"
                className="w-full h-full object-cover rounded-3xl"
              />
              <div className="absolute -bottom-4 -left-4 bg-background-50/95 backdrop-blur-sm rounded-full px-5 py-2.5">
                <span className="text-xs font-semibold text-foreground-800 flex items-center gap-2 whitespace-nowrap">
                  <span className="w-2 h-2 bg-accent-500 rounded-full animate-pulse"></span>
                  实时追踪中 · 今日更新128条
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <div className="w-6 h-10 border-2 border-background-50/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 bg-background-50/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}